import axios from 'axios';

import { responseInterceptor, errorInterceptor } from './interceptors';

const getStoredToken = () => {
  const tokenFromLocalStorage = localStorage.getItem('APP_ACCESS_TOKEN');
  if (!tokenFromLocalStorage) return '';

  try {
    return JSON.parse(tokenFromLocalStorage);
  } catch {
    localStorage.removeItem('APP_ACCESS_TOKEN');
    return '';
  }
};

const Api = axios.create({
  baseURL: window.env.REACT_APP_URL_BASE,
});

// Sem isso, o Authorization ficava fixo no valor lido do localStorage no momento em que
// este módulo era avaliado (uma única vez, no carregamento da página) — como o login não
// dá mais reload da página, um logout seguido de login com outro usuário mandava as
// primeiras requisições ainda com o token do usuário anterior. Lendo o token aqui, a cada
// requisição, ele sempre reflete o localStorage atual.
Api.interceptors.request.use((config) => {
  const storedToken = getStoredToken();
  config.headers.Authorization = storedToken ? `Bearer ${storedToken}` : '';
  return config;
});

Api.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);


export { Api };